import { XingletLoader } from '@xing-com/crate-xinglet';

export const Component = (): React.ReactNode => {
  return <XingletLoader name="@xing-com/crate-communication-root" />;
};
